import { useContext } from 'react'

import { NewPodcastModalContext } from '../providers/NewPodcastModalProvider'

export const useNewPodcastModalContext = () => {
  const newPodcastModalContext = useContext(NewPodcastModalContext)

  if (newPodcastModalContext === undefined) {
    throw new Error('newPodcastModalContext must be used within a NewPodcastModalProvider')
  }

  return newPodcastModalContext
}
